import { Component, Input, OnInit } from '@angular/core';
import { IndustryContentService } from '../../shared/industry-content.service';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';

@Component({
  selector: 'lp2-industry-content-tile',
  templateUrl: './industry-content-tile.component.html',
  styleUrls: ['./industry-content-tile.component.scss'],
})
export class IndustryContentTileComponent implements OnInit {
  @Input() content: StudyBundleCourseDto = <StudyBundleCourseDto>{};
  @Input() carouselLevel: string;
  @Input() shouldSaveTime: boolean;
  tileId: string;

  constructor(private industryContentService: IndustryContentService) {}

  ngOnInit() {
    if (this.content && this.content.title) {
      const [title, subtitle, type] = this.content.title
        .split('|')
        .map((item) => item.trim());
      this.content = { ...this.content, title, subtitle, type };
    }

    if (this.content && this.content.id) {
      this.tileId = 'industry-' + this.content.id;
    }
  }

  openModalPlayer() {
    this.industryContentService.openActivity(this.content, this.shouldSaveTime);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/industry-content-tile/industry-content-tile.component.ts